// extracted by mini-css-extract-plugin
module.exports = {"headerText":"SliderInput_headerText__1BmHD","textStyle":"SliderInput_textStyle__5O_2x"};